import { ClientLinkPrimary } from '@fukku/button/ClientLink/Primary'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { HOME_PATH } from 'my-purchases/constants/paths'
import { sendOnClickDiscover } from 'my-purchases/utils/analytics/analyticsEvents'

import text from 'fukku/styles/texts.module.scss'
import styles from './NoPurchasesContainer.module.scss'

export function NoPurchasesContainer() {
	const { t } = useLabels()

	const handleDiscoverLatest = () => {
		sendOnClickDiscover()
	}

	return (
		<div
			className={styles.container}
			data-testid='myPurchases.list.noPurchases'
		>
			<h2 className={`${text.titleL} ${styles.title}`}>
				{t('myPurchases.empty.title')}
			</h2>
			<p className={styles.body}>{t('myPurchases.empty.bodycopy')}</p>
			<ClientLinkPrimary
				href={HOME_PATH}
				onClick={handleDiscoverLatest}
				className={styles.button}
			>
				{t('myPurchases.empty.discover.button')}
			</ClientLinkPrimary>
		</div>
	)
}
